import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";

const GetBankList = () =>
  request({
    url: ApiURL.Query.GetBankList,
    method: RequestType.GET, 
  });
    
const DataQuery = {
  GetBankList
};

export default DataQuery;
